module.exports = __webpack_public_path__ + "static/img/areaB_03.fab25c1.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/areaB_03.png
// module id = 1264
// module chunks = 1